import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../apiConfig';
import ArtworkUpload from './ArtworkUpload';
import toast from 'react-hot-toast';

const EditArtworkWrapper = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [artwork, setArtwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArtwork = async () => {
      try {
        const response = await api.get(endpoints.artwork.get(id));
        setArtwork(response.data);
      } catch (err) {
        console.error('Error fetching artwork:', err);
        setError(err.response?.data?.message || 'Failed to fetch artwork');
        toast.error('Failed to fetch artwork details');
      } finally {
        setLoading(false);
      }
    };

    fetchArtwork();
  }, [id]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading artwork details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/dashboard')} className="btn-primary">
          Return to Dashboard
        </button>
      </div>
    );
  }

  if (!artwork) {
    return (
      <div className="error-container">
        <h2>Artwork Not Found</h2>
        <p>The artwork you're looking for doesn't exist or you don't have permission to edit it.</p>
        <button onClick={() => navigate('/dashboard')} className="btn-primary">
          Return to Dashboard
        </button>
      </div>
    );
  }

  return <ArtworkUpload initialData={artwork} />;
};

export default EditArtworkWrapper; 